import { Alert, AlertStatus } from 'dtos/alerts/alert.dto';
import { PaginatedResponse, toPaginatedResponse } from 'dtos/common/api.dto';
import { apiClient } from 'services/api-client';

export class AlertService {
  static async list(orgId: string, storeId: string, status?: AlertStatus, page = 1, pageSize = 8): Promise<PaginatedResponse<Alert>> {
    const params = new URLSearchParams();
    if (status) params.set('status', status);
    params.set('page', String(page));
    params.set('pageSize', String(pageSize));
    const response = await apiClient.get<Alert[]>(`/orgs/${orgId}/stores/${storeId}/alerts?${params}`);
    return toPaginatedResponse(response, page, pageSize);
  }

  static async acknowledge(_orgId: string, alertId: string): Promise<Alert> {
    const response = await apiClient.post<Alert>(`/orgs/${_orgId}/alerts/${alertId}/acknowledge`);
    return response.data;
  }

  static async resolve(_orgId: string, alertId: string): Promise<Alert> {
    const response = await apiClient.post<Alert>(`/orgs/${_orgId}/alerts/${alertId}/resolve`);
    return response.data;
  }

  static async dismiss(_orgId: string, alertId: string): Promise<Alert> {
    const response = await apiClient.post<Alert>(`/orgs/${_orgId}/alerts/${alertId}/dismiss`);
    return response.data;
  }
}

